import './index.scss'
// import '../../assets/scripts/myNiceScroll'
// import {resizeScroll} from '../../assets/scripts/myNiceScroll'
import Swiper from 'swiper/dist/js/swiper.min.js'


// 计算销售网络右侧滚动区域最大高度
$(document).ready(function(){
  if($(window).width() >= 768){
    let Hei = $('.section2 .left .tab').outerHeight() + 30 - $('.section2 .right .slide-title').eq(0).outerHeight()
    $('.section2 .right .swiper-slide ul').css('max-height', Hei+'px')
  }else{
    $('.section2 .right .swiper-slide ul').css('max-height', '11rem');
  }
})
$(window).resize(function(){
  if($(window).width() >= 768){
    let Hei = $('.section2 .left .tab').outerHeight() + 30 - $('.section2 .right .slide-title').eq(0).outerHeight()
    $('.section2 .right .swiper-slide ul').css('max-height', Hei+'px')
  }else{
    $('.section2 .right .swiper-slide ul').css('max-height', '11rem');
  }
})

var swiper = new Swiper(".section2 .right .mySwiper", {
  allowTouchMove: false,
  effect : 'fade',
  fadeEffect: {
    crossFade: true,
  },
  on: {
    init: function(swiper){
      $('.section2 .left .tab div').eq(this.activeIndex).addClass('active')
    },
    slideChangeTransitionStart: function(){
      $('.section2 .left .tab div').eq(this.activeIndex).addClass('active').siblings().removeClass('active')
    },
  },
});

$('.section2 .left .tab div').hover(function(){
  let index = $(this).index()
  swiper.slideTo(index)
})
